import { useState } from "react";
import { sanitizeHTML } from "../../helper/SanitizeHTML";
const Authors = ({ toc, aboutAuthor }) => {
  const [show, setShow] = useState(false);
  const [tocSize, setTocSize] = useState(0);
  const [authorSize, setAuthorSize] = useState(0);
  const handleShowHide = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="container-fluid toc_authors ">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 toc_main_container ">
            <div className="container show_more_container">
              <div className="row">
                <div
                  className={
                    show ||
                    ((tocSize.offsetHeight < 195 || !toc) &&
                      (authorSize.offsetHeight < 195 || !aboutAuthor))
                      ? "toc1"
                      : "toc1 toc1_height"
                  }
                  style={{ border: "solid red 0px" }}
                >
                  <div
                    className={
                      show ||
                      ((tocSize.offsetHeight < 195 || !toc) &&
                        (authorSize.offsetHeight < 195 || !aboutAuthor))
                        ? "toc2"
                        : "toc2 toc2_height"
                    }
                  >
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 no-padding-margin">
                      {toc && (
                        <>
                          <div className="toc_heading pull-left">
                            Table of Contents
                          </div>
                          <div className="chapter_lists pull-left">
                            <div
                              style={{
                                float: "left",
                                border: "solid red 0px",
                              }}
                              className="toc1_1"
                            >
                              <p ref={(el) => setTocSize(el)}>
                                <span
                                  dangerouslySetInnerHTML={sanitizeHTML(toc)}
                                />
                              </p>
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    {aboutAuthor && (
                      <div
                        className="col-xs-12 col-sm-12 col-md-6 col-lg-6 no-padding-margin"
                        style={{ paddingBottom: show ? "25px" : "0px" }}
                      >
                        <div className="toc_heading pull-left">
                          About the Author
                        </div>
                        <div className="about_the_authors pull-left">
                          <div
                            style={{ float: "left", border: "solid red 0px" }}
                            className="toc1_2"
                          >
                            <p ref={(el) => setAuthorSize(el)}>
                              <span
                                dangerouslySetInnerHTML={sanitizeHTML(
                                  aboutAuthor
                                )}
                              />
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {(tocSize.offsetHeight > 195 ||
                    authorSize.offsetHeight > 195) && (
                    <div
                      className={
                        show
                          ? "toc_show_more toggle_show_more_text"
                          : "toc_show_more toc_show_more_fade toggle_show_more_text"
                      }
                      style={{ paddingTop: show ? "0px" : "100px" }}
                    >
                      <span
                        style={{ cursor: "pointer" }}
                        rel={0}
                        className="showmoretxt pull-left"
                        onClick={handleShowHide}
                      >
                        {!show ? "Show More" : "Less"}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Authors;
